import script from "./MainWrapper.vue?vue&type=script&setup=true&lang=js"
export * from "./MainWrapper.vue?vue&type=script&setup=true&lang=js"

import "vue-multiselect/dist/vue-multiselect.css?vue&type=style&index=0&lang=css"

const __exports__ = script;

export default __exports__